module.exports = __webpack_public_path__ + "img/icons BFr_38.cd4b55f2.png";